import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import BottomNav from "./BottomNav";
import MobileTopBar from "./MobileTopBar";
import PoweredByFooter from "./PoweredByFooter";
import TermsGate from "./TermsGate";
import { WorkspaceBrandingProvider } from "../contexts/WorkspaceBrandingContext";

export default function Layout() {
    return (
        <WorkspaceBrandingProvider>
            <div className="flex min-h-screen bg-[#0a0a0a] text-zinc-100">
                <a href="#portal-main" className="portal-skip-link" data-testid="skip-to-content-link">Skip to content</a>
                <Sidebar />
                <main className="flex-1 flex flex-col min-w-0">
                    <MobileTopBar />
                    <div id="portal-main" tabIndex={-1} className="flex-1 pb-20 md:pb-0" data-testid="app-main-content">
                        <Outlet />
                    </div>
                    <PoweredByFooter />
                </main>
                <BottomNav />
                <TermsGate />
            </div>
        </WorkspaceBrandingProvider>
    );
}
